import { Rich } from "@/components/Rich";
import { resolveImg } from "@/lib/sections";

export const SectionShell = ({ id, testId, children }) => (
  <section id={id} data-testid={testId} className="relative border-t border-white/5 py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
  </section>
);

export const SectionHeading = ({ eyebrow, title, subtitle }) => (
  <div className="max-w-2xl">
    {eyebrow && <div className="mb-3 font-mono text-xs text-orange-400">{eyebrow}</div>}
    {title && (
      <h2 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl">
        <Rich text={title} />
      </h2>
    )}
    {subtitle && <p className="mt-4 text-slate-400 sm:text-lg">{subtitle}</p>}
  </div>
);

export const Img = ({ src, className, alt = "" }) =>
  src ? <img src={resolveImg(src)} alt={alt} loading="lazy" className={className} /> : null;
